export const SLIDEDOWN_CSS_CLASSES = {
    allowButton: "onesignal-slidedown-allow-button",
    body: "slidedown-body",
    buttonIndicatorHolder: "onesignal-button-indicator-holder",
    cancelButton: "onesignal-slidedown-cancel-button",
    container: "onesignal-slidedown-container",
    dialog: "onesignal-slidedown-dialog",
    footer: "slidedown-footer",
    reset: "onesignal-reset",
    savingStateButton: "onesignal-saving-state-button",
    slideUp: 'slide-up',
    slideDown: 'slide-down',
    closeSlidedown: 'close-slidedown',
    icon: 'slidedown-body-icon',
    message: 'slidedown-body-message',
    defaultIcon: 'default-icon',
    loadingContainer: "onesignal-loading-container",
    clearfix: "clearfix"
};
export const TOAST_CLASSES = {
    toastText: 'onesignal-toast-text'
};
export const TOAST_IDS = {
    toastText: 'onesignal-toast-text'
};
export const SLIDEDOWN_CSS_IDS = {
    allowButton: "onesignal-slidedown-allow-button",
    body: "slidedown-body",
    buttonIndicatorHolder: "onesignal-button-indicator-holder",
    cancelButton: "onesignal-slidedown-cancel-button",
    container: "onesignal-slidedown-container",
    dialog: "onesignal-slidedown-dialog",
    footer: "slidedown-footer",
    normalSlidedown: "normal-slidedown",
    loadingContainer: "onesignal-loading-container",
};
export const SLIDEDOWN_BUTTON_CLASSES = {
    alignRight: 'align-right',
    primary: 'primary',
    secondary: 'secondary',
    slidedownButton: 'slidedown-button'
};
export const TAGGING_CONTAINER_CSS_CLASSES = {
    categoryLabelInput: "onesignal-category-label-input",
    categoryLabelText: "onesignal-category-label-text",
    categoryLabel: "onesignal-category-label",
    checkmark: "onesignal-checkmark",
    taggingContainer: "tagging-container",
    taggingContainerCol: "tagging-container-col",
    loadingMessage: "onesignal-loading-message"
};
export const TAGGING_CONTAINER_CSS_IDS = {
    taggingContainer: "tagging-container",
};
export const DEFAULT_ICON = `data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg'` +
    ` viewBox='0 0 40 40'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath fill-rule='evenodd'` +
    ` clip-rule='evenodd' d='M33.232 28.434a2.5 2.5 0 001.768.733 1.667 1.667 0 010 ` +
    `3.333H5a1.667 1.667 0 110-3.333 2.5 2.5 0 002.5-2.5v-8.104A13.262 13.262 0 0118.333` +
    ` 5.122V1.667a1.666 1.666 0 113.334 0v3.455A13.262 13.262 0 0132.5 18.563v8.104a2.5` +
    ` 2.5 0 00.732 1.767zM16.273 35h7.454a.413.413 0 01.413.37 4.167 4.167 0 11-8.28 0` +
    ` .417.417 0 01.413-.37z' fill='%23BDC4CB'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath` +
    ` id='clip0'%3E%3Cpath fill='%23fff' d='M0 0h40v40H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E`;
export const DANGER_ICON = `data:image/svg+xml;charset=UTF-8,%3csvg width='16' height='16' view` +
    `Box='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.98775 -0.001144` +
    `06C5.85015 0.0338508 3.81219 0.908665 2.31442 2.43419C1.565 3.18031 0.973715 4.06987 0.575897 ` +
    `5.04969C0.17808 6.02952 -0.0180997 7.07949 -0.000914196 8.13686C-0.00214385 9.17005 0.200528 1` +
    `0.1933 0.595487 11.148C0.990446 12.1028 1.56993 12.9702 2.30072 13.7005C3.03151 14.4309 3.8992` +
    `5 15.0098 4.85421 15.4042C5.80916 15.7986 6.83256 16.0007 7.86575 15.9989H8.00842C10.1467 15.9` +
    `769 12.1889 15.1075 13.6869 13.5816C15.185 12.0557 16.0165 9.99781 15.9991 7.85952C16.0015 6.8` +
    `138 15.7949 5.77814 15.3913 4.81345C14.9876 3.84876 14.3952 2.97451 13.6488 2.24213C12.9023 1.` +
    `50974 12.017 0.933994 11.0448 0.548751C10.0726 0.163508 9.03324 -0.0234551 7.98775 -0.00114406` +
    `ZM6.99909 11.0269C6.99428 10.8961 7.01558 10.7658 7.06175 10.6434C7.10792 10.521 7.17803 10.40` +
    `91 7.26797 10.3141C7.35792 10.2191 7.4659 10.143 7.58559 10.0903C7.70529 10.0375 7.8343 10.009` +
    `2 7.96509 10.0069H7.98309C8.24616 10.0074 8.49882 10.1097 8.6881 10.2924C8.87739 10.4751 8.988` +
    `6 10.724 8.99842 10.9869C9.00331 11.1176 8.98207 11.248 8.93594 11.3704C8.8898 11.4928 8.8197 ` +
    `11.6048 8.72974 11.6998C8.63978 11.7948 8.53176 11.8709 8.41202 11.9236C8.29229 11.9763 8.1632` +
    `3 12.0046 8.03242 12.0069H8.01442C7.75145 12.006 7.49897 11.9036 7.30976 11.721C7.12054 11.538` +
    `3 7.00923 11.2896 6.99909 11.0269ZM7.33242 8.33219V4.33219C7.33242 4.15538 7.40266 3.98581 7.5` +
    `2768 3.86079C7.65271 3.73576 7.82227 3.66552 7.99909 3.66552C8.1759 3.66552 8.34547 3.73576 8.` +
    `47049 3.86079C8.59551 3.98581 8.66575 4.15538 8.66575 4.33219V8.33219C8.66575 8.509 8.59551 8.` +
    `67857 8.47049 8.80359C8.34547 8.92862 8.1759 8.99886 7.99909 8.99886C7.82227 8.99886 7.65271 8` +
    `.92862 7.52768 8.80359C7.40266 8.67857 7.33242 8.509 7.33242 8.33219Z' fill='%23E54B4D'/%3e%3c/svg%3e`;
export const COLORS = {
    greyLoadingIndicator: "#95A1AC",
    whiteLoadingIndicator: "#FFFFFF"
};
export const TAGGING_CONTAINER_STRINGS = {
    fetchingPreferences: "Fetching your preferences"
};
export const CHANNEL_CAPTURE_CONTAINER_CSS_CLASSES = {
    channelCaptureContainer: 'channel-capture-container',
    inputWithValidationElement: 'input-with-validation-element',
    onesignalErrorInput: 'onesignal-error-input',
    onesignalSmsInput: 'iti-onesignal-sms-input',
    onesignalEmailInput: 'onesignal-email-input',
    onesignalValidationElementHidden: 'onesignal-validation-element-hidden',
    onesignalValidationElement: 'onesignal-validation-element',
};
export const CHANNEL_CAPTURE_CONTAINER_CSS_IDS = {
    channelCaptureContainer: 'channel-capture-container',
    smsInputWithValidationElement: 'sms-input-with-validation-element',
    emailInputWithValidationElement: 'email-input-with-validation-element',
    onesignalSmsInput: 'iti-onesignal-sms-input',
    onesignalEmailInput: 'onesignal-email-input',
    onesignalSmsValidationElement: 'onesignal-sms-validation-element',
    onesignalEmailValidationElement: 'onesignal-email-validation-element',
};
const STATE = {
    subscribed: "state-subscribed",
    unsubscribed: "state-unsubscribed",
};
export const CUSTOM_LINK_CSS_CLASSES = {
    containerClass: "onesignal-customlink-container",
    subscribeClass: "onesignal-customlink-subscribe",
    explanationClass: "onesignal-customlink-explanation",
    resetClass: "onesignal-reset",
    hide: "hide",
    state: STATE,
};
export const CUSTOM_LINK_CSS_SELECTORS = {
    containerSelector: `.${CUSTOM_LINK_CSS_CLASSES.containerClass}`,
    subscribeSelector: `.${CUSTOM_LINK_CSS_CLASSES.subscribeClass}`,
    explanationSelector: `.${CUSTOM_LINK_CSS_CLASSES.explanationClass}`,
};
//# sourceMappingURL=constants.js.map